import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, fromEvent, Observable, Subscription } from 'rxjs';
import { ConnectToMxComponent } from '../connect-to-mx/connect-to-mx.component';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { CreateMiniFromStepperComponent } from '@app/shared/component/create-mini-from-stepper/create-mini-from-stepper.component';
import { map, takeWhile } from 'rxjs/operators';
import { AddDocumentComponent } from '@app/modules/vault/components/add-document/add-document.component';
import { MobileSideNavService } from '@app/shared/services/mobile-nav/mobile-nav.service';
import { CommonVaultSUbHeaderSubjectService } from '@app/modules/vault/components/common/common-vault-sub-header/common-vault-sub-header.component.service';
import { Router } from '@angular/router';
import { WorkSpaceService } from '@app/shared/services/work-space-service/work-space.service';
import { UserService } from '@app/shared/services';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-institution',
  templateUrl: './add-institution.component.html',
  styleUrls: ['./add-institution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddInstitutionComponent implements OnInit, OnDestroy {
  @Output() closeSideDrawerEmitter = new EventEmitter();
  @Input() isFromDiscovery?: boolean = false;
  @Input() switchFromUser?: boolean = false;
  @Input() selectedItemsArray?: Array<any> = [];
  subscription = new Subscription();
  isLoadingData = signal(true);
  mxDatList = signal([]);
  resizeObservable$: Observable<Event>;
  screenWidth: number;
  userId;
  workspaceId;
  worksapceUsers = [];
  currentWorkspaceUserId;
  currentActiveIndex = 0;
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }];
  defaultFolders = [];
  connectedAccounts = signal([]);
  disconnectedAccounts = signal([]);
  isComponentActive = signal(true);
  expandedItems = signal([]);
  firstItemOnToggle: any = null;
  indexOfFirstItemOnToggle: number = -1;
  private worksapceMmbers$ = new BehaviorSubject<any[]>([]);

  private MxconnectionService = inject(MxconnectionService);
  private dialog = inject(MatDialog);
  private toastr = inject(ToastrService);
  private router = inject(Router);
  private _cd = inject(ChangeDetectorRef);
  private _workSpaceService = inject(WorkSpaceService);
  private mxTaskbarService = inject(MxTaskbarService);
  private mobileNavService = inject(MobileSideNavService);
  private CommonVaultSUbHeaderSubjectService = inject(CommonVaultSUbHeaderSubjectService);
  private userService = inject(UserService);

  ngOnDestroy(): void {
    this.isComponentActive.set(false);
    this.mobileNavService.handleFinancialAccountSetupSidenav(false);
    this.CommonVaultSUbHeaderSubjectService.handleOpenMXDrawer(false);
    this.subscription.unsubscribe();
  }
  mouseEnterHandler(event: MouseEvent, assetExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !assetExpansionPanel.expanded) {
      assetExpansionPanel.open();
    }
  }
  addInstitution() {
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        title: 'Financial Institution',
        stop_form_creation: false,
        enable_linking: true,
        currentValutUserId: this.userId,
        ...(this.workspaceId && { workspace_id: this.workspaceId, workspace_user_id: this.currentWorkspaceUserId }),
      },
    });
    this.subscription.add(dialogRef.componentInstance.mxDialogMinimized.pipe(takeWhile(() => this.isComponentActive())).subscribe(() => {}));
    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((val) => {
          if (val.success) {
            this.isLoadingData.set(true);
            this.getUserData();
          }
        })
    );
  }

  disconnect(item) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Connection',
        materialIcon: 'trash',
        text: `Are you sure you want to delete the connection to ${item.name}?`,
        proceedTitle: 'Delete',
        checkBoxTitle: 'Delete all linked templates',
      },
    });
    this.subscription.add(
      sharedDialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((data) => {
          const { confirmation, deleteAllChecked } = data;

          if (confirmation) {
            let data: {
              userId: string;
              memberGuid: string;
              delete_templates?: boolean;
              workspace_id?: string;
              workspace_user_id?: string;
            } = {
              userId: this.userId,
              memberGuid: item.guid,
            };
            if (deleteAllChecked) data = { ...data, delete_templates: true };
            if (this.workspaceId) data = { ...data, workspace_id: this.workspaceId, workspace_user_id: this.currentWorkspaceUserId };
            this.subscription.add(
              this.MxconnectionService.deleteUserMemberAccount(data)
                .pipe(takeWhile(() => this.isComponentActive()))
                .subscribe(() => {
                  this.toastr.success('Member deleted successfully.');
                  this.getUserData();
                })
            );
          }
        })
    );
  }
  handleEmitEvents(value) {
    if (!!value.linkForm) {
      const { item } = value;
      this.moveAssetItem(item);
    } else if (!!value.openForm) {
      const { file } = value;
      const { vaultUserForm } = file;

      if (!!vaultUserForm) {
        const dialogOpen = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: { file: vaultUserForm, mode: 'edit', isintelligent: false, isfileListLoad: true },
          panelClass: 'full-window-dialog-add-document',
          autoFocus: false,
        });

        this.subscription.add(
          dialogOpen
            .afterClosed()
            .pipe(takeWhile(() => this.isComponentActive()))
            .subscribe(() => this.getUserData())
        );
      }
    } else {
      this.getUserData();
    }
  }

  reconnect(account) {
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        currentValutUserId: this.userId,
        isUpdate: true,
        stop_form_creation: true,
        account,
        ...(this.workspaceId && { workspace_id: this.workspaceId, workspace_user_id: this.currentWorkspaceUserId }),
      },
    });

    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((val) => (val.success ? this.getUserData() : ''))
    );
  }
  private loginService = inject(LoginStoreEffects);
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;

    this.resizeObservable$ = fromEvent(window, 'resize');

    this.subscription.add(
      this.resizeObservable$.pipe(takeWhile(() => this.isComponentActive())).subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    if (this.router.url.includes('workspace')) {
      const parseUrl = this.router.url.split('/');
      this.workspaceId = parseUrl[2];
    }

    this.subscription.add(
      this.loginService.loginObject.pipe(takeWhile(() => this.isComponentActive())).subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId = state.data.id;
        }
      })
    );

    if (this.workspaceId) {
      this.getWorkSpaceTypes();
    } else {
      this.getUserData();
    }
  }

  getWorkSpaceTypes() {
    this.subscription.add(
      this._workSpaceService.getWorkSpaceTypes(this.workspaceId, 'data_feeds').subscribe((res) => {
        let updatedObject = [];
        this.indexOfFirstItemOnToggle = res.findIndex((obj) => obj.toggle === 'on');
        this.firstItemOnToggle = this.indexOfFirstItemOnToggle !== -1 ? res[this.indexOfFirstItemOnToggle] : null;
        res.forEach((element, index) => {
          let tempEllemt = {
            ...element,
            status: index === this.indexOfFirstItemOnToggle ? 'active' : 'inactive',
          };
          updatedObject.push(tempEllemt);
        });
        this.worksapceUsers = updatedObject;
        this.currentWorkspaceUserId = this.firstItemOnToggle.user_id;
        this.currentActiveIndex = this.indexOfFirstItemOnToggle ?? 0;
        this.worksapceMmbers$.next(updatedObject);
        if (this.firstItemOnToggle) {
          this.getUserData();
        } else {
          this.isLoadingData.set(false);
        }
        this._cd.detectChanges();
      })
    );
  }

  getUserData() {
    this.subscription.add(
      this.MxconnectionService.getUserStatusMX(this.workspaceId ? this.currentWorkspaceUserId : this.userId, this.workspaceId)
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((res) => {
          this.mxDatList.set(res.mx);
          this.disconnectedAccounts.set(this.mxDatList().filter((data) => data?.connection_status !== 'CONNECTED'));
          this.connectedAccounts.set(this.mxDatList().filter((data) => data?.connection_status === 'CONNECTED'));
          this.isLoadingData.set(false);
        })
    );
  }

  handleSidenavMenuNavigation(user_id: string, toggle: string, index: number) {
    if (index !== this.currentActiveIndex) {
      this.setStatusForSidenavMenu(index);
      this.currentWorkspaceUserId = user_id;
      this.connectedAccounts.set([]);
      this.disconnectedAccounts.set([]);
      this.mxDatList.set([]);
      this.expandedItems.set([]); // Clear expansion state when switching users
      if (toggle === 'on') {
        this.isLoadingData.set(true);
        this.getUserData();
      }
    }
  }

  setStatusForSidenavMenu(activeIndex) {
    if (activeIndex != -1) {
      for (let i = 0; i < this.worksapceUsers.length; i++) {
        this.worksapceUsers[i].status = i === activeIndex ? 'active' : 'inactive';
      }
      this.currentActiveIndex = activeIndex;
    } else {
      this.currentActiveIndex = undefined;
      for (let step of this.worksapceUsers) {
        step.status = 'inactive';
      }
    }
  }

  hasToggleOn$ = this.worksapceMmbers$.pipe(map((response) => response.some((obj) => obj.toggle === 'on')));

  closeSideDrawer() {
    this.closeSideDrawerEmitter.emit();
  }
  selectedAccounts = signal([]);
  handleSelectedAccounts(data: Array<any> | undefined) {
    if (!data) return;

    const checkedItems = data.filter((item) => item.checked);
    const unCheckedItems = data.filter((item) => !item?.checked);
    const updatedArrayB = this.selectedAccounts().filter((itemB) => !unCheckedItems.some((itemA) => itemA.id === itemB.id));

    this.selectedAccounts.set([...new Set(updatedArrayB)]);
    this.selectedAccounts.set([
      ...new Set([
        ...checkedItems.filter((item) => !this.selectedAccounts().some((selected) => selected.id === item.id)),
        ...this.selectedAccounts(),
      ]),
    ]);
  }
  clearSession() {
    this.selectedAccounts.set([]);
    this.mxDatList.set(
      this.mxDatList().map((account) => {
        return {
          ...account,
          userAccounts: account.userAccounts.map((userAct) => ({ ...userAct, checked: false })),
        };
      })
    );
  }
  moveChecklists(event) {
    if (event === 'clearSelection') {
      this.clearSession();
    } else if (event === 'move') {
      this.moveAssetItem();
    }
  }

  notInUseChecklists(event) {
    if (event === 'clearSelection') {
      this.clearSession();
    } else if (event === 'notInUse') {
      this.notInUseAssetItem();
    }
  }

  updateNotInUseStatus(item) {
    return new Promise((resolve) => {
      this.subscription.add(
        this.userService
          .updatemxMemberAccountStatus({
            user_account_guid: item.guid,
            user_account_status: 'not in use',
          })
          .subscribe((res) => {
            resolve(res);
          })
      );
    });
  }

  notInUseAssetItem() {
    const promises = [];
    for (const item of this.selectedAccounts()) {
      if (item.status === 'in use') {
        promises.push(this.updateNotInUseStatus(item));
      }
    }
    Promise.all(promises).then(() => {
      this.clearSession();
      this.getUserData();
      this.toastr.success('Status updated successfully.');
      this.handleEmitEvents({ somePhone: true });
    });
  }

  moveAssetItem(item?: Record<any, any>) {
    const dialogRef = this.dialog.open<CreateMiniFromStepperComponent>(CreateMiniFromStepperComponent, {
      data: {
        inbox_attachment_id: undefined,
        vault_id: undefined,
        vaultFormId: 18,
        title: 'Move to',
        vaultType: 'Mx Financial Account',
        hub_vault_user_form_id: undefined,
        origin: 'MxFinancialAccount',
        selectedAccounts: !item ? this.selectedAccounts() : [item],
        discovery_sub_type_id: 'b22421a0-946e-4651-9e37-2d6ee07b0bf9',
      },
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((res) => {
          this.clearSession();
          if (res?.status) {
            this.getUserData();
          }
        })
    );
  }

  rearrangeByConnectionStatus(arr) {
    return arr.sort((a, b) => {
      if (a.connection_status !== 'CONNECTED' && b.connection_status === 'CONNECTED') {
        return -1; // Move disconnected to the top
      } else if (a.connection_status === 'CONNECTED' && b.connection_status !== 'CONNECTED') {
        return 1; // Move connected to the top
      }
      return 0; // Leave order unchanged if both are the same
    });
  }
  onPanelOpened(index) {
    this.expandedItems.set([...this.expandedItems(), index]);
  }
  onPanelClosed(index) {
    this.expandedItems.set([...this.expandedItems().filter((i) => i !== index)]);
  }
}
